import React from 'react';
import MultiSelectAll from './MultiSelectAll';
import MultiSelect from './MultiSelect';
import { IMultiselectCheckboxes } from './type';

const MultiselectCheckboxes: React.FC<IMultiselectCheckboxes> = ({ options, includeAll = false }) =>
    includeAll ? <MultiSelectAll options={options} /> : <MultiSelect options={options} />;

export default MultiselectCheckboxes;
